<script>
    export default {
        name: "NotificationMixin",

        methods: {
            showSuccess(message, title = 'Успех') {
                this.$bvToast.toast(message, {title: title, variant: 'success'});
            },
            showErrors(errors, title = 'Ошибка') {
                let message = '';
                if (errors !== undefined) {
                    if (typeof errors === 'string') {
                        message = errors;
                    } else {
                        message = errors.length > 0 ? errors.map(e => e.message).reduce((a, c) => a + '; ' + c) : 'Неизвестная ошибка';
                    }
                }
                this.$bvToast.toast(message, {title: title, variant: 'danger'});
            },
        },
    }
</script>